/** Canvas drawImage rectangles, clipped before sampling a packed texture atlas. */
export function imageQuad(width: number, height: number, args: readonly number[]) {
  let [sx, sy, sw, sh, dx, dy, dw, dh] =
    args.length === 8 ? args : [0, 0, width, height, args[0]!, args[1]!, args[2] ?? width, args[3] ?? height];
  if (![sx, sy, sw, sh, dx, dy, dw, dh].every(Number.isFinite) || !sw || !sh || !dw || !dh) return null;
  if (sw < 0) {
    sx += sw;
    sw = -sw;
  }
  if (sh < 0) {
    sy += sh;
    sh = -sh;
  }
  if (dw < 0) {
    dx += dw;
    dw = -dw;
  }
  if (dh < 0) {
    dy += dh;
    dh = -dh;
  }
  const x0 = Math.max(0, sx),
    y0 = Math.max(0, sy);
  const x1 = Math.min(width, sx + sw),
    y1 = Math.min(height, sy + sh);
  if (x1 <= x0 || y1 <= y0) return null;
  return {
    sx: x0,
    sy: y0,
    sw: x1 - x0,
    sh: y1 - y0,
    dx: dx + ((x0 - sx) * dw) / sw,
    dy: dy + ((y0 - sy) * dh) / sh,
    dw: ((x1 - x0) * dw) / sw,
    dh: ((y1 - y0) * dh) / sh,
  };
}
